import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { cn } from '../../utils/classnames.js';
import Box from '../box/index.js';
import Icon from '../icon/index.js';
import Text from '../text/index.js';
function Accordion({ summary, details, className, toggleDataTestId, }) {
    const [expanded, setExpanded] = useState(false);
    const toggleExpanded = () => {
        setExpanded((previousExpanded) => !previousExpanded);
    };
    return (_jsxs(Box, { className: cn('ui-flex ui-w-full ui-flex-col ui-p-4', className), children: [summary, expanded && details, _jsxs("button", { type: "button", className: "ui-mt-4 ui-flex ui-w-full ui-items-center ui-justify-center", "data-testid": toggleDataTestId, onClick: toggleExpanded, children: [_jsx(Text, { className: "ui-text-gray-600 theme-dark:ui-text-neutral-400", monospace: true, size: 12, uppercase: true, children: expanded ? 'Show Less' : 'Show More' }), _jsx(Icon, { className: cn('ui-ml-1 ui-text-gray-600 ui-transition-transform ui-duration-200 theme-dark:ui-text-neutral-400', expanded ? 'ui-rotate-180' : ''), name: "triangle-down", size: 16 })] })] }));
}
export default Accordion;
